export { default as CompanyViewHeadCompany } from './CompanyViewHeadCompany';
